import { useState } from 'react';
import './App.css';
import { MainInfo } from './MainInfo';
import { Work } from './Work';
import { Contact } from './Contact';
import { BrowserRouter, Link, Route, Router, Routes } from 'react-router-dom';

function App() {
  const [navOpen, setNavOpen] = useState(false);

  return <div>
    <nav className="navbar navbar-expand-lg navbar-dark">
      <div className="container">
        <Link to="/"><img src="assets/isentropy-logo-color.png" style={{ width: "15%", height: "15%" }} /></Link>
        <button className="navbar-toggler" type="button" onClick={() => setNavOpen(!navOpen)} aria-controls="navbarSupportedContent" aria-expanded={navOpen} aria-label="Toggle navigation"><span className="navbar-toggler-icon"></span></button>
        <div className={"navbar-collapse" + (navOpen ? "" : " collapse")} id="navbarSupportedContent">
          <ul className="navbar-nav ms-auto mb-2 mb-lg-0">
            <li className="nav-item px-2"><Link className="nav-link active" to="/" onClick={() => setNavOpen(false)}>HOME</Link></li>
            <li className="nav-item px-2"><Link className="nav-link active" to="/work" onClick={() => setNavOpen(false)}>WORK</Link></li>
            <li className="nav-item px-2"><Link className="nav-link active" to="/contact" onClick={() => setNavOpen(false)}>CONTACT</Link></li>
          </ul>
        </div>
      </div>
    </nav>
      <Routes>
        <Route path="/" element={<MainInfo />} />
        <Route path="/work" element={<Work />} />
        <Route path="/contact" element={<Contact />} />
      </Routes>

    <div className="bg-image-full" >
      <div style={{ height: "384px" }}></div>
    </div>
    <footer className="py-5">
      <div className="container">
        <p className="m-0 text-center text-white">
          Copyright &copy; Isentropy LLC 2026. All rights reserved.
          <br />
          Isentropy was founded in 2013, and has Vermont ID# 0284283.
        </p>
      </div>
    </footer>


  </div>
}

export default App;
